import { useCallback, useSyncExternalStore } from 'react';
import { getActiveToast, subscribe } from './toast';
import type { Toast } from './toast';

export function useActiveToast(): Toast | null {
  const sub = useCallback((cb: () => void) => subscribe(cb), []);
  return useSyncExternalStore(sub, getActiveToast, getActiveToast);
}
